import { msg } from "@lingui/core/macro";

export const maxPermitsPerLocationRuleMessages = {
	name: msg({ message: "Max Permits Per Location" }),
	description: msg({ message: "Limits the number of permits that can be active at a time per location" }),
	errors: {
		limitReached: msg({ message: "Maximum permits per location reached" }),
	},
} as const;
